import {EntityModel} from "@fedeltapointofsale/data-client";
import {LoyaltyCardData, LoyaltyCardProductSelection} from "./loyalty-card.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class LoyaltyCardEntityModel extends EntityModel<LoyaltyCardData> {
    constructor(injector: Injector) {
        super(injector, LoyaltyCardData);
    }

    protected override onBeforeSaveEntity(entityData: LoyaltyCardData) {
        super.onBeforeSaveEntity(entityData);
        switch (this.data.productSelection) {
            case LoyaltyCardProductSelection.SELLABLE:
                this.data.properties.categoryId = null;
                this.data.properties.customObjectId = null;
                break;
            case LoyaltyCardProductSelection.CATEGORY:
                this.data.properties.sellableId = null;
                this.data.properties.customObjectId = null;
                break;
            case LoyaltyCardProductSelection.CUSTOM_GROUP:
                this.data.properties.sellableId = null;
                this.data.properties.categoryId = null;
                break;
        }
    }
}
